import React from 'react';
import tpl from '../templates/frp';
import BaseNewCardView from '../../../../../../Cards/views/BaseNewCardView';
import {canUseDOM} from '../../../../../../../helpers/canUseDOM';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            isMobile: canUseDOM ? window.innerWidth <= 900 : false,
            widgets_2: []
        };
    }

    updateWidth = () => {
        this.setState({isMobile: window.innerWidth <= 900});
    };

    componentDidMount() {
        super.componentDidMount();
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/business/gov/frp_file',
            widgetKey: 'widgets_2'
        });
        window.addEventListener('resize', this.updateWidth);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        window.removeEventListener('resize', this.updateWidth);
    }

    static displayName = 'Gov.FRP';
}
